import { render, staticRenderFns } from "./SponsorsPreview.vue?vue&type=template&id=3cf893b6&scoped=true"
import script from "./SponsorsPreview.vue?vue&type=script&lang=js"
export * from "./SponsorsPreview.vue?vue&type=script&lang=js"
import style0 from "./SponsorsPreview.vue?vue&type=style&index=0&id=3cf893b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf893b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
